import React, { useEffect, useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import { Card, Avatar, Row, Col, message, Pagination, Select } from "antd";
import * as actions from "../../../store/actions/index";
import { useHistory } from "react-router-dom";
import Tabs from "../../../components/Tab/Tab";
import _ from "lodash";
import axiosRequest from "../../../axios-request/request.methods";
import "./ApplicationAll.css";
import NoRecordsFound from "../../NoRcordsFound/NoRecordsFound";
import Loader from "../../Loader/Loader";
import { stoageSetter, stoageGetter, checkAgent, checkPartnerUser } from "../../../helpers";
import { renderEnachStatus, renderMandateStatus } from "./SubsequentPaymentUtility";
import { DownOutlined, UpOutlined } from "@ant-design/icons";
import { routeAsPerProposalStatus, isGiftCityChannel } from "../../../config/router.config";
import TriggerSubsequentPayment from "./TriggerSubsequentPayment";
import { tabMenuApplication } from "./ApplicationAll";
import TeamPerformanceTable from "../teamPerformanceTable";
import { AthenaProductsRouteHandler, PaymentFrequencyConvertor } from "../../../config/product.config";
import * as leadActions from "../../../store/actions/leads";
import { ProposalStatusCheck, renderMedicalTestStatus } from "./ProposalStatusUtility";
import FilterDropdown from "../filterDropdown";
import { getUniqueArray } from "../../../store/utility";

const WIPApplication = () => {
  const [width, setWidth] = useState(window.innerWidth);
  const [fetchApplicationList, setfetchApplicationList] = useState([]);
  const [currentPageNumber, setcurrentPageNumber] = useState(1);
  const [proposalNumberSearch, setProposerNumberSearch] = useState("");

  const [proposalStatus, setProposalStatus] = useState("");

  const [totalLeads, settotalLeads] = useState(0);
  const [loader, setLoader] = useState(false);
  const [isshowMore, setisshowMore] = useState([]); //show more index values
  const [showSubPaymentModal, setShowSubPaymentModal] = useState(false);
  const [triggerSubPaymentData, setTriggerSubPaymentData] = useState(null);

  const dispatch = useDispatch();
  const history = useHistory();

  const id = useSelector((state) => state.login?.user?.id);
  const userId = useSelector((state) => state?.login?.userId);
  const leadsData = useSelector((state) => state.leads);
  const userTreeData = useSelector((state) => state?.home?.user_tree);
  const showProposalTable = useSelector((state) => state.leads.showProposalTable);
  const selectedFilter = useSelector(state => state.leads.selectedFilterByVal);



  const [firstValue, setFirstValue] = useState("");
  const [secondValue, setSecondValue] = useState("");
  const [openSecond, setOpenSecond] = useState(false);
  const [secondDropData, setSecondDropData] = useState([]);
  const [firsrDrop, setFirstDrop] = useState([]);
  const [currentFilter, setCurrentFilter] = useState(selectedFilter);

  const breakpoint = 620;

  useEffect(() => {
    const handleWindowResize = () => setWidth(window.innerWidth);
    window.addEventListener("resize", handleWindowResize);
    return () => window.removeEventListener("resize", handleWindowResize);
  }, [width]);

  const WebHeightProduct = { height: width > breakpoint ? "30px" : "" };
  // useEffect(() => {
  //   getItemToDisplayFromStatus(currentPageNumber, proposalStatus);
  //   console.log("((((((((((2)))))))))):-=======---=====-->>>");
  // }, []);
  useEffect(() => {
    // 🔹 Step 1: Initialize team dropdown data
    getDataForFirstDropdownTeam();

    // 🔹 Step 2: Retrieve saved values from storage
    const hierarchyId = stoageGetter("hierarchyId");
    const teamId = stoageGetter("teamMemberId");

    // 🔹 Step 3: If we have stored values and global tab is "team"
    if (hierarchyId && teamId && leadsData?.globalTab === "team") {
      setFirstValue(hierarchyId);

      // Filter reporting users by hierarchy
      const _teamData =
        userTreeData?.reporting_users?.filter(
          (el) => el.hierarchy_id === hierarchyId
        ) || [];

      // ✅ Deduplicate dropdown entries
      const uniqueTeamData = getUniqueArray(_teamData);

      setSecondDropData(uniqueTeamData);
      setSecondValue(teamId);
      setOpenSecond(true);

      console.log("Restored unique dropdown from storage:", uniqueTeamData);
    }
    // 🔹 Step 4: Else restore from Redux (if exists)
    else if (
      leadsData?.proposalTeamData &&
      Object.keys(leadsData?.proposalTeamData).length !== 0
    ) {
      handleTeamMemberClick(leadsData?.proposalTeamData);
    }
  }, []);

  useEffect(() => {
    if (leadsData?.globalTab === "self") {
      setSecondValue("");
      setOpenSecond(false);
      // Trigger API call to fetch current user's proposals
      getItemsToDisplay(currentPageNumber, proposalNumberSearch);
      // getItemToDisplayFromStatus(currentPageNumber, proposalStatus);
    }
  }, [leadsData?.globalTab]);


  useEffect(() => {
    if (secondValue) {
      // Fetch proposals for the selected team member after the state update
      setcurrentPageNumber(1);
      getItemsToDisplay(1, proposalNumberSearch);
      // getItemToDisplayFromStatus(1, proposalStatus, secondValue);
    }
  }, [secondValue]);

  // useEffect(() => {
  //   let hierarchyId = stoageGetter("hierarchyId");
  //   let teamId = stoageGetter("teamMemberId");

  //   console.log('hierarchyId=-----------',hierarchyId)
  //   console.log('teamId=-----------',teamId)

  // }, []);



  const getItemsToDisplay = async (Nextpage, policyId, filterbyValue) => {
    setLoader(true);

    let res = null;

    // Determine the correct userId based on team member selection and hierarchy level
    let dynamicUserId = id; // Default to current user's id

    dynamicUserId = leadsData?.globalTab === "team" && secondValue ? secondValue : id
    let _filter = leadsData?.globalTab === "self" ? "all" : filterbyValue || currentFilter;
    res = await axiosRequest.get(`user/get_agent_proposal/${dynamicUserId}?proposalStatus=WIP&skip=${(Nextpage - 1) * 15}&sort_status=&sortByFlter=Proposalstarted&searchByDisplayProposal=${proposalStatus}&searchType=policyId&searchtxt=${policyId}&filterby=${_filter}`);
    // console.log("page new result-->", res);

    if (res?.errCode === 529) {
      setfetchApplicationList([]);
      settotalLeads(0);
      setLoader(false);
    } else if (res.length > 0) {
      setLoader(false);
      setfetchApplicationList(res[0]);
      settotalLeads(res[1][0].count);
    } else {
      setLoader(false);
      return <NoRecordsFound />;
    }
  };

  //------------- filter by status api call start -----------------------
  const getItemToDisplayFromStatus = async (Nextpage, status) => {
    setLoader(true);
    let res = null;
    let dynamicUserId = id;
    // if (leadsData?.globalTab === "team" && secondValue) {
    //   dynamicUserId = (checkAgent() === false || checkPartnerUser()) ? secondValue : id;
    // }
    // dynamicUserId = leadsData?.globalTab === "team" && leadsData?.proposalTeamData ? leadsData?.proposalTeamData?._id : id
    dynamicUserId = leadsData?.globalTab === "team" && secondValue ? secondValue : id
    res = await axiosRequest.get(`user/get_agent_proposal/${dynamicUserId}?proposalStatus=WIP&skip=${(Nextpage - 1) * 15}&sort_status=&sorByFlter=Proposalstarted&searchByDisplayProposal=${status}`);

    if (res?.errCode === 529) {
      setfetchApplicationList([]);
      settotalLeads(0);
      setLoader(false);
    } else if (res.length > 0) {
      setLoader(false);
      setfetchApplicationList(res[0]);
      settotalLeads(res[1][0].count);
    } else {
      setLoader(false);
      return <NoRecordsFound />;
    }
  };

  // replicate team view helpers from All tab
  const toCapitalize = (strText) => {
    try {
      if (strText !== "" && strText !== null && typeof strText !== undefined) {
        var _str = strText.toLowerCase();
        var collection = _str.split(" ");
        var modifyStrigs = [];
        _str = "";
        for (var i = 0; i < collection.length; i++) {
          modifyStrigs[i] = collection[i].charAt(0).toUpperCase() + collection[i].slice(1);
          _str = _str + modifyStrigs[i] + " ";
        }
        return _str;
      } else {
        return "";
      }
    } catch (err) { }
  };

  const getDataForFirstDropdownTeam = () => {
    let hierarAgentList = userTreeData?.reporting_hierarchies;
    hierarAgentList?.forEach((el) => {
      el.label = el.dispValue;
    });
    userTreeData?.reporting_users?.forEach((el) => {
      el.label = el.full_name;
      el.value = el._id;
    });
    setFirstDrop(hierarAgentList);
  };

  const handleFirstDropdown = (event) => {
    // 🔹 Toggle second dropdown open/close
    setOpenSecond(!!event);

    // 🔹 Set first dropdown (hierarchy) value
    setFirstValue(event);
    setSecondValue("");
    stoageSetter("hierarchyId", event);

    // 🔹 Prepare label/value for each user safely
    const updatedUsers = userTreeData?.reporting_users?.map((el) => ({
      ...el,
      label: toCapitalize(el.full_name),
      value: el._id,
    }));

    // 🔹 Filter users by selected hierarchy
    const filteredTeam =
      updatedUsers?.filter((el) => el.hierarchy_id === event) || [];

    // ✅ Deduplicate by _id using helper
    const uniqueTeamData = getUniqueArray(filteredTeam, "_id");

    // 🔹 Update second dropdown with unique list
    setSecondDropData(uniqueTeamData);

    // 🔹 Select first user if available
    if (uniqueTeamData.length > 0) {
      setSecondValue(uniqueTeamData[0]._id);
      stoageSetter("teamMemberId", uniqueTeamData[0]._id);
    } else {
      setSecondValue("");
      stoageSetter("teamMemberId", "");
    }

    console.log("✅ Unique team data (First dropdown):", uniqueTeamData);
  };


  const handleSecondDropdown = async (event) => {
    setSecondValue(event);
    stoageSetter("teamMemberId", event);

    // if (event) {
    //   setcurrentPageNumber(1);
    //   await getItemsToDisplay(1, proposalNumberSearch);
    //   await getItemToDisplayFromStatus(1, proposalStatus);
    // }
  };

  const handleTeamMemberClick = (member) => {
    // 🔹 Clear previous data to refresh UI
    setfetchApplicationList([]);
    setSecondDropData([]); // Prevent old/duplicate data before setting new one

    // 🔹 Get stored hierarchy/team values
    const hierarchyId = stoageGetter("hierarchyId");
    const teamId = stoageGetter("teamMemberId");

    // 🔹 Determine active hierarchy
    const activeHierarchyId = member.hierarchy_id || hierarchyId;
    if (activeHierarchyId) {
      setFirstValue(activeHierarchyId);
      stoageSetter("hierarchyId", activeHierarchyId);

      // Filter team data by hierarchy
      const filteredTeam =
        userTreeData?.reporting_users?.filter(
          (el) => el.hierarchy_id === activeHierarchyId
        ) || [];

      // ✅ Deduplicate with helper
      const uniqueTeamData = getUniqueArray(filteredTeam, "_id");

      setSecondDropData(uniqueTeamData);
      console.log("✅ Unique team dropdown (handleTeamMemberClick):", uniqueTeamData);
    }

    // 🔹 Determine active team member
    const activeTeamMemberId = member._id || teamId;
    if (activeTeamMemberId) {
      setSecondValue(activeTeamMemberId);
      stoageSetter("teamMemberId", activeTeamMemberId);
    }

    // 🔹 Trigger Redux and UI updates
    dispatch(leadActions.proposalTeamSelect(true));
    dispatch(leadActions.showProposalTable(true));
    setOpenSecond(true);
    setcurrentPageNumber(1);
  };



  //------------- filter by status api call start -----------------------

  const getRandomColor = () => {
    var letters = "0123456789ABCDEF";
    var color = "#";
    for (var i = 0; i < 6; i++) {
      color += letters[Math.floor(Math.random() * 16)];
    }
    return color;
  };

  const nameShorter = (str) => {
    let str1 = "UU";
    if (str != "" && str != undefined) {
      str1 = str?.toUpperCase();
      let arr = str1?.split(" ");
      let fLatter = arr[0]?.charAt(0);
      let sLatter = arr[1]?.charAt(0);
      str1 = (fLatter || "UU") + (sLatter || "");
    }

    return str1;
  };

  const ViewHeadline = (e) => {
    let ProposalLocalID = {
      proposalID: e?._id,
    };
    stoageSetter("propsalid", ProposalLocalID);
    history.push("/finalSubmit");
  };

  const routeHandler = async (item) => {
    var id = "";

    var productCode = "";

    productCode = item.productId.product_code;

    id = item._id;
    let ProposalLocalID = {
      proposalID: id,
    };
    stoageSetter("propsalid", ProposalLocalID);

    let tracker_res = await axiosRequest.get(`user/getProposal/${id}`);

    if (tracker_res?.errCode !== 256) {
      dispatch(actions.fetchAllProposalSuccess(tracker_res[0]));
      dispatch(actions.fetchBi(tracker_res[0]?.benefitIllustration));
      dispatch(actions.fetchEinsurance(tracker_res[0]?.elinsuranceAccountDetails));
      dispatch(actions.fetchFinancialDetails(tracker_res[0]?.FinancialDetails));
      dispatch(actions.fetchAboutCustomer(tracker_res[0]?.AboutCustomer));
      dispatch(actions.fetchHealthDetails(tracker_res[0]?.HealthDetailsSection));
      dispatch(actions.fetchPreviousPolicyDetails(tracker_res[0]?.PreviousPolicyDetails));
      dispatch(actions.fetchNominationDetails(tracker_res[0]?.NominationDetails));
      dispatch(actions.fetchProposalDetails(tracker_res[0]?.ProposerDetails));
      dispatch(actions.fetchPayments(tracker_res[0]?.paymentOptions));
      dispatch(actions.AddENACHDetails(tracker_res[0]?.eNachStatus));
      dispatch(actions.fetchDelaration(tracker_res[0]?.Declaration));

      const routingURL = routeAsPerProposalStatus(item);

      if (routingURL === "currentLocationURL") {
        if (item?.currentLocationURL === null || item?.currentLocationURL === undefined || item?.currentLocationURL === "") {
          AthenaProductsRouteHandler(history, productCode);
        } else {
          history.push(item?.currentLocationURL);
        }
      } else {
        history.push(routingURL);
      }
    }
  };


  const showJourneyTerminateReason = (reason) => {
    if (reason.includes("Kindly explore other products.")) {
      let newReason = reason.split("Kindly explore other products.");
      let reasonToDisplay = newReason[0];
      message.warn(reasonToDisplay);
    } else {
      message.warn(reason);
    }
  };

  const handlePageClick = async (page) => {
    setcurrentPageNumber(page);
    await getItemsToDisplay(page, proposalNumberSearch);
    await getItemToDisplayFromStatus(page, proposalStatus);
    await setisshowMore([]);
  };

  const handleProposalFilter = (policyId) => {
    setProposerNumberSearch(policyId);

    if (policyId === "" || policyId === null || policyId === undefined) {
      getItemsToDisplay(currentPageNumber, policyId);
    } else {
      setcurrentPageNumber(1);
      getItemsToDisplay(1, policyId);
    }
  };

  const handleProposalStatusFilter = (status) => {
    setProposalStatus(status);

    if (status === "" || status === null || status === undefined) {
      getItemToDisplayFromStatus(currentPageNumber, status);
    } else {
      setcurrentPageNumber(1);
      getItemToDisplayFromStatus(1, status);
    }
  };

  const showMoreFunc = (index) => {
    let new_val = [...isshowMore];
    new_val.push(index);
    setisshowMore(new_val);
  };
  const showLessFunc = (index) => {
    let new_val = [...isshowMore];
    _.remove(new_val, (new_val_item) => new_val_item == index);
    setisshowMore(new_val);
  };

  const content = (
    <div style={{ borderRadius: "10px" }}>
      <p style={{ cursor: "pointer" }}>Enach Status</p>
      <p style={{ cursor: "pointer" }}>Payment Status</p>
      <p style={{ cursor: "pointer" }}>Docs Status</p>
    </div>
  );

  const handleTriggerSubsequentPayment = async (item) => {
    const result = await axiosRequest.get(`user/checkMandateRetry?proposalId=${item?.policyId}`);

    if (result?.retry === true) {
      setTriggerSubPaymentData(item);
      setShowSubPaymentModal(true);
    }
  };

  const pageLoadAfterSubsequent = () => {
    getItemsToDisplay(currentPageNumber, proposalNumberSearch);
  };

  const handleViewDetails = async (item) => {
    var id = "";
    var productCode = "";
    productCode = item?.productId?.product_code;

    id = item._id;
    let ProposalLocalID = {
      proposalID: id,
    };
    stoageSetter("propsalid", ProposalLocalID);
    const login_user_data = stoageGetter("user");
    const employeeCode = login_user_data?.employeeCode;
    let getproposalApi = `user/getProposal/${id}`;

    if (leadsData?.globalTab === "team") {
      console.log("Im in team view chnageing api ", leadsData)
      getproposalApi = `user/getProposal/${id}?Supervisar_id=${employeeCode}&view_details=true`
    }

    console.log("getapi---", getproposalApi)

    let tracker_res = await axiosRequest.get(getproposalApi);

    if (tracker_res?.errCode !== 256) {
      dispatch(actions.fetchAllProposalSuccess(tracker_res[0]));
      dispatch(actions.fetchBi(tracker_res[0]?.benefitIllustration));
      dispatch(actions.fetchEinsurance(tracker_res[0]?.elinsuranceAccountDetails));
      dispatch(actions.fetchFinancialDetails(tracker_res[0]?.FinancialDetails));
      dispatch(actions.fetchAboutCustomer(tracker_res[0]?.AboutCustomer));
      dispatch(actions.fetchHealthDetails(tracker_res[0]?.HealthDetailsSection));
      dispatch(actions.fetchPreviousPolicyDetails(tracker_res[0]?.PreviousPolicyDetails));
      dispatch(actions.fetchNominationDetails(tracker_res[0]?.NominationDetails));
      dispatch(actions.fetchProposalDetails(tracker_res[0]?.ProposerDetails));
      dispatch(actions.fetchPayments(tracker_res[0]?.paymentOptions));
      dispatch(actions.AddENACHDetails(tracker_res[0]?.eNachStatus));

      dispatch(actions.fetchDelaration(tracker_res[0]?.Declaration));

      // Route to appropriate tab based on proposal status
      const routingURL = routeAsPerProposalStatus(item);

      if (routingURL === "currentLocationURL") {
        if (item?.currentLocationURL === null || item?.currentLocationURL === undefined || item?.currentLocationURL === "") {
          AthenaProductsRouteHandler(history, productCode);
        } else {
          history.push(item?.currentLocationURL);
        }
      } else {
        history.push(routingURL);
      }
    }
  };

  const handleFilterUpdate = (value) => {
    setCurrentFilter(value);
    console.log('Selected filter in parent:', value);
    getItemsToDisplay(1, proposalNumberSearch, value);
  };

  return (
    <>
      <Tabs header="Applications" tabMenu={tabMenuApplication} activeKey="WIPApplication" proposalFilter={handleProposalFilter} handleProposalStatusFilter={handleProposalStatusFilter} />
      <>
        <Loader formloader={loader} />
      </>

      {showProposalTable ? (
        <>
          {leadsData?.globalTab === "team" && (
            <div className="main_tab_1" style={{ marginLeft: "5rem" }}>
              <Row align="middle">
                <Row gutter={16} style={{ flex: 1 }}>
                  {leadsData?.globalTab === "team" && (
                    <FilterDropdown onFilterChange={handleFilterUpdate} />
                  )}
                  <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                    <div className="hierarchy">
                      <p style={{ marginBottom: "5px" }}>Select Hierarchy</p>
                      <Select className="firstdropdown" value={firstValue} style={{ width: "100%" }} onChange={handleFirstDropdown} placeholder="Select Hierarchy" options={firsrDrop}></Select>
                    </div>
                  </Col>
                  <Col xs={12} sm={12} md={12} lg={4} xl={4}>
                    {openSecond && (
                      <div className="hierarchy">
                        <p style={{ marginBottom: "5px" }}>Select Team Member</p>
                        <Select className="seconddropdown" value={secondValue} style={{ width: "100%" }} onChange={(item) => handleSecondDropdown(item)} placeholder="Select Team Member" options={secondDropData}></Select>
                      </div>
                    )}
                  </Col>
                </Row>
              </Row>
            </div>
          )}
          <Row justify={"center"}>
            {!fetchApplicationList ? (
              <Loader formloader={loader} />
            ) : (
              fetchApplicationList?.map((item, index) => (
                <Col sm={18} md={18} lg={11} xl={11} index={index} key={index} style={{ width: "100%" }}>
                  <div className="LeadCard-Main-Page-Container">
                    <Card className="lead-card-desktop" hoverable={false}>
                      <div className="main-avtar">
                        <div className="avatar-and-status">
                          <Avatar
                            style={{
                              paddingTop: "-40px",
                              lineHeight: "none",
                              backgroundColor: getRandomColor(),
                            }}
                            size={{ xl: 50 }}
                          >
                            {nameShorter(item.benefitIllustration.NameofLifeAssured)}
                          </Avatar>
                        </div>
                      </div>

                      <div className="mainContent">
                        <div className="content">
                          <div className="content-header1">
                            <div className="avtar-data">
                              <div className="otp-data1">
                                <p className="user-name-text capitalize">{item?.benefitIllustration?.NameofLifeAssured}</p>
                              </div>
                            </div>
                          </div>
                          <hr
                            style={{
                              width: "95%",
                              margin: "3px -30px 4px 0px",
                              opacity: "0.5",
                              color: "lightgray",
                            }}
                          />

                          {width < 620 ? (
                            <>
                              <Row gutter={16}>
                                <Col xs={21} sm={21} md={21} lg={24} xl={24}>
                                  <label style={{ fontSize: 12 }}>
                                    <b>Product Name</b>
                                  </label>
                                  <div>{item?.productId?.productName}</div>
                                </Col>
                              </Row>

                              <Row gutter={16}>
                                <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                  <label style={{ fontSize: 12 }}>
                                    <b>Proposal Number</b>
                                  </label>
                                  <div>{item?.policyId}</div>
                                </Col>
                                <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                  <label style={{ fontSize: 12 }}>
                                    <b>Draft Date</b>
                                  </label>
                                  <div>{item?.lastupdatedOn}</div>
                                </Col>
                              </Row>

                              {width < 620 && !isshowMore.includes(index) ? null : (
                                <>
                                  <Row gutter={16}>
                                    <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                      <label style={{ fontSize: 12 }}>
                                        <b>Premium Frequency</b>
                                      </label>
                                      <div>{PaymentFrequencyConvertor(item?.benefitIllustration?.PremiumMode)}</div>
                                    </Col>
                                    <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                      <label style={{ fontSize: 12 }}>
                                        <b>Policy Term</b>
                                      </label>
                                      <div>{item.benefitIllustration?.PolicyTerm ? `${item.benefitIllustration?.PolicyTerm} year(s)` : "- years"}</div>
                                    </Col>
                                  </Row>

                                  <Row gutter={16}>
                                    <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                      <label style={{ fontSize: 12 }}>
                                        <b>Premium Amount</b>
                                      </label>
                                      <div>{item?.benefitIllustration?.annualisedPremium}</div>
                                    </Col>
                                    <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                      <label style={{ fontSize: 12 }}>Payment Status</label>
                                      <div>
                                        <label style={{ color: item?.paymentOptions?.paymentStatus === "SUCCESS" ? "green" : item?.paymentOptions?.paymentStatus === "PENDING" ? "gold" : "black" }}>{item?.paymentOptions?.paymentStatus}</label>
                                      </div>
                                    </Col>
                                  </Row>

                                  <Row gutter={16}>
                                    <Col xs={11} sm={11} md={11} lg={12} xl={12}>
                                      <label style={{ fontSize: 12 }}>
                                        <b>Mandate Status</b>
                                      </label>
                                      <div>{renderMandateStatus(item)}</div>
                                    </Col>
                                  </Row>

                                  <Row gutter={16}>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                      <label style={{ fontSize: 12 }}>
                                        <b>Proposal Status</b>
                                      </label>
                                      {/* <div>{item?.proposalStatus}</div> */}
                                      <div>{ProposalStatusCheck(item)}</div>
                                    </Col>
                                  </Row>
                                  <Row gutter={16}>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                      <label style={{ fontSize: 12 }}>
                                        <b>Opportunity ID</b>
                                      </label>
                                      {/* <div>{item?.proposalStatus}</div> */}
                                      <div>{item?.opportunityId || '-'}</div>
                                    </Col>
                                  </Row>
                                  <Row gutter={16}>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                      <label style={{ fontSize: 12 }}>
                                        <b>Product of Interest</b>
                                      </label>
                                      <div>{item?.selected_Product || "-"}</div>
                                    </Col>
                                  </Row>

                                  {/* Enach status */}
                                  <Row gutter={16}>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                      <label style={{ fontSize: 12 }}>
                                        <b>Enach Status</b>
                                      </label>
                                      <div>{renderEnachStatus(item) || "-"}</div>
                                    </Col>
                                  </Row>

                                  <Row gutter={16} style={{ marginTop: "10px" }}>
                                    <Col xs={24} sm={24} md={24} lg={24} xl={24}>
                                      <label style={{ fontSize: 12 }}>
                                        <b>Medical Test Status</b>
                                      </label>
                                      <div>{renderMedicalTestStatus(item)}</div>
                                    </Col>
                                  </Row>


                                </>
                              )}
                            </>
                          ) : (
                            <div className="content-body Datainfo-Main-Container">
                              <div className="Dateinfo-Container-imp">
                                <Card.Grid hoverable={false} className="grid-style">
                                  <p className="text-type">Proposal Number</p>
                                  <p className="text-content">{item?.policyId}</p>
                                </Card.Grid>
                                <Card.Grid hoverable={false} className="grid-style">
                                  <p className="text-type">Product Name</p>
                                  <p className="text-content-v2" style={WebHeightProduct}>
                                    {item?.productId?.productName}
                                  </p>
                                </Card.Grid>
                                <Card.Grid hoverable={false} className="grid-style">
                                  <p className="text-type">Mandate Status</p>
                                  <p className="text-content">{renderMandateStatus(item)}</p>
                                </Card.Grid>
                                <Card.Grid hoverable={false} className="grid-style">
                                  <p className="text-type">Premium Frequency</p>
                                  <p className="text-content">{PaymentFrequencyConvertor(item?.benefitIllustration?.PremiumMode)}</p>
                                </Card.Grid>

                                <Card.Grid hoverable={false} className="grid-style AllocatedBy-Heading">
                                  <p className="text-type">Policy Term</p>
                                  <p className="text-content">{item.benefitIllustration?.PolicyTerm ? item.benefitIllustration?.PolicyTerm : "- years"}</p>
                                </Card.Grid>
                                <Card.Grid hoverable={false} className="grid-style Appoinment-Heading">
                                  <p className="text-type">Draft Date</p>
                                  {/* <p className="text-content">{moment(item?.updatedAt).format("DD/MM/YYYY")}</p> */}
                                  <p className="text-content">{item?.lastupdatedOn}</p>
                                </Card.Grid>
                                <Card.Grid hoverable={false} className="grid-style">
                                  <p className="text-type">Premium Amount</p>
                                  <p className="text-content">{item?.benefitIllustration?.annualisedPremium}</p>
                                </Card.Grid>

                                <Card.Grid hoverable={false} className="grid-style">
                                  <p className="text-type">Payment Status</p>
                                  <p className="text-content" style={{ fontWeight: "bold", color: item?.paymentOptions?.paymentStatus === "SUCCESS" ? "#06c106" : item?.paymentOptions?.paymentStatus === "PENDING" ? "#ffd900" : "" }}>
                                    {item?.paymentOptions?.paymentStatus}
                                  </p>
                                </Card.Grid>
                                <Card.Grid hoverable={false} className="grid-style">
                                  <p className="text-type">Proposal Status</p>
                                  {/* <p className="text-content-v2">{item?.proposalStatus}</p> */}
                                  <p className="text-content-v2">{ProposalStatusCheck(item)}</p>
                                </Card.Grid>
                                <Card.Grid hoverable={false} className="grid-style">
                                  <p className="text-type">Opportunity ID</p>
                                  {/* <p className="text-content-v2">{item?.proposalStatus}</p> */}
                                  <p className="text-content-v2">{item?.opportunityId || "-"}</p>
                                </Card.Grid>
                                <Card.Grid hoverable={false} className="grid-style">
                                  <p className="text-type">Product of Interest</p>
                                  <p className="text-content-v2">{item?.leadId?.selected_Product || "-"}</p>
                                </Card.Grid>
                                <Card.Grid hoverable={false} className="grid-style">
                                  <p className="text-type">Enach Status</p>
                                  <p className="text-content-v2">{renderEnachStatus(item) || "-"}</p>
                                </Card.Grid>

                                <Card.Grid hoverable={false} className="grid-style" style={{ marginTop: "10px" }}>
                                  <p className="text-type">Medical Test Status</p>
                                  <p className="text-content-v2">{renderMedicalTestStatus(item)}</p>
                                </Card.Grid>

                              </div>
                            </div>
                          )}
                        </div>

                        <div>
                          {width < 620 ? (
                            <div className="card_footer_btns">
                              {/* In team view, only show View Details button */}
                              {leadsData?.globalTab === "team" ? (
                                <button className="show_more_less" onClick={() => handleViewDetails(item)}>
                                  View Details
                                </button>
                              ) : (
                                <>
                                  {isGiftCityChannel() === false && item?.mandateRetry === true ? (
                                    <button className="show_more_less" onClick={() => handleTriggerSubsequentPayment(item)}>
                                      Trigger Subsequent Payment
                                    </button>
                                  ) : null}

                                  {item?.terminateJourney === true ? (
                                    <button className="terminatedButton" onClick={() => showJourneyTerminateReason(item?.terminateReason)}>
                                      Journey Terminated
                                    </button>
                                  ) : (
                                    <>
                                      {item?.proposalStatus == "Login successful - Login Successful" ? (
                                        <button className="show_more_less" onClick={() => ViewHeadline(item)}>
                                          View Details
                                        </button>
                                      ) : (
                                        <button className="show_more_less" onClick={() => routeHandler(item)}>
                                          Resume
                                        </button>
                                      )}
                                    </>
                                  )}
                                </>
                              )}

                              <div>
                                {!isshowMore.includes(index) ? (
                                  <label
                                    className="showMoreLabel"
                                    role="button"
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        // Checks if Enter is pressed
                                        showMoreFunc(index);
                                      }
                                    }}
                                    onClick={() => showMoreFunc(index)}
                                    style={{ marginTop: 15 }}
                                  >
                                    Show More <DownOutlined />
                                  </label>
                                ) : (
                                  <label
                                    className="showMoreLabel"
                                    role="button"
                                    onKeyDown={(e) => {
                                      if (e.key === "Enter") {
                                        // Checks if Enter is pressed
                                        showLessFunc(index);
                                      }
                                    }}
                                    onClick={() => showLessFunc(index)}
                                    style={{ marginTop: 15 }}
                                  >
                                    Show Less <UpOutlined />
                                  </label>
                                )}
                              </div>
                            </div>
                          ) : (
                            <div className="card_below_btns_others">
                              <Row align="right">
                                {/* In team view, only show View Details button */}
                                {leadsData?.globalTab === "team" ? (
                                  <button className="show_more_less" onClick={() => handleViewDetails(item)}>
                                    View Details
                                  </button>
                                ) : (
                                  <>
                                    {isGiftCityChannel() === false && item?.mandateRetry === true ? (
                                      <button className="show_more_less" onClick={() => handleTriggerSubsequentPayment(item)}>
                                        Trigger Subsequent Payment
                                      </button>
                                    ) : null}

                                    {item?.terminateJourney === true ? (
                                      <button className="terminatedButton" onClick={() => showJourneyTerminateReason(item?.terminateReason)}>
                                        Journey Terminated
                                      </button>
                                    ) : (
                                      <>
                                        {item?.proposalStatus == "Login successful - Login Successful" ? (
                                          <button className="show_more_less" onClick={() => ViewHeadline(item)}>
                                            View Details
                                          </button>
                                        ) : (
                                          <button className="show_more_less" onClick={() => routeHandler(item)}>
                                            Resume
                                          </button>
                                        )}
                                      </>
                                    )}
                                  </>
                                )}
                              </Row>
                            </div>
                          )}
                        </div>
                      </div>
                    </Card>
                  </div>
                </Col>
              ))
            )}
          </Row>

          {!fetchApplicationList.length ? (
            <>
              <br />
              <NoRecordsFound />
            </>
          ) : (
            <div style={{ display: "flex", justifyContent: "center" }}>
              <Row gutter={16} style={{ width: "100%" }}>
                <Col sm={24} md={23} lg={23} xl={24} style={{ display: 'flex', justifyContent: 'center' }}>
                  <Pagination responsive current={currentPageNumber} onChange={handlePageClick} total={totalLeads} defaultPageSize={15} showSizeChanger={false} />
                </Col>
              </Row>
            </div>
          )}
        </>
      ) : (
        <div style={{ padding: 20 }}>
          {userTreeData?.reporting_users?.length > 0 || userTreeData?.reporting_managers?.length > 0 ? (
            <>
              <FilterDropdown onFilterChange={handleFilterUpdate} />
              <TeamPerformanceTable showManagerColumn={(checkAgent() === true && !checkPartnerUser()) ? false : true} onTeamMemberClick={handleTeamMemberClick} />
            </>
          ) :
            null
          }
        </div>
      )}

      {showSubPaymentModal === true ? <TriggerSubsequentPayment isModalOpen={showSubPaymentModal} setIsModalOpen={setShowSubPaymentModal} proposalData={triggerSubPaymentData} pageLoadAfterSubsequent={pageLoadAfterSubsequent} /> : null}
    </>
  );
};

export default WIPApplication;
